export default class State {
  is_auth = false;

  keep_session = false;
}
